(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lua-before-after-slider"] && !Shopify.designMode) return;
  try {
    
// One listener, on the control itself. The version this replaces tracked drag
// state and listened on window for mousemove and touchmove; a range input
// needs neither, and it works with a keyboard.
document.querySelectorAll('.lua-ba__range').forEach((range) => {
  const frame = range.closest('.lua-ba__frame');
  if (!frame) return;
  const sync = () => frame.style.setProperty('--lua-ba-pos', `${range.value}%`);
  range.addEventListener('input', sync);
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-best-sellers"] && !Shopify.designMode) return;
  try {
    
class LuaCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.cards = Array.from(this.querySelectorAll('[data-card]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));

    if (this.track && this.cards.length) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = this.cards.indexOf(entry.target);
            this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.cards.forEach((card) => this.observer.observe(card));
    }

    this.restoreWishlist();
    this.addEventListener('click', this.onClick);

    this.setupAutoplay();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.removeEventListener('click', this.onClick);
    this.stopAutoplay();
    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.visibilityHandler = null;
    }
  }

  /*
    Autoplay — 09/08/2026, excepción concedida a la home móvil congelada
    ("Sí, abre la excepción y añade autoplay en móvil"). Mismas reglas que
    el carrusel de escritorio (lua-d-best-sellers.liquid), adaptadas a que
    aquí no hay flechas -- el gesto que pausa es el toque, no el ratón:
    se para con touchstart/pointerdown y con el foco, respeta
    prefers-reduced-motion (por eso no arranca en absoluto si el sistema lo
    pide), se para si la pestaña no está visible, y vuelve al principio al
    llegar al final en vez de rebotar.
  */
  setupAutoplay() {
    if (!this.track || this.cards.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.autoplayMs = 4000;
    this.autoplayPaused = false;
    this.autoplayTimer = null;

    const pause = () => {
      this.autoplayPaused = true;
      this.stopAutoplay();
    };
    const resume = () => {
      this.autoplayPaused = false;
      this.startAutoplay();
    };

    this.track.addEventListener('pointerdown', pause);
    this.track.addEventListener('pointerup', resume);
    this.track.addEventListener('pointercancel', resume);
    this.track.addEventListener('touchstart', pause, { passive: true });
    this.track.addEventListener('touchend', resume, { passive: true });
    this.addEventListener('focusin', pause);
    this.addEventListener('focusout', resume);
    this.visibilityHandler = () => {
      if (document.hidden) this.stopAutoplay();
      else resume();
    };
    document.addEventListener('visibilitychange', this.visibilityHandler);

    this.startAutoplay();
  }

  startAutoplay() {
    if (this.autoplayPaused || !this.track) return;
    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(() => this.autoplayTick(), this.autoplayMs);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  autoplayTick() {
    if (document.hidden) return;
    const track = this.track;
    const max = track.scrollWidth - track.clientWidth;
    if (max <= 1) return;

    const style = getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    const first = this.cards[0];
    const step = (first ? first.getBoundingClientRect().width : track.clientWidth) + gap;

    if (track.scrollLeft >= max - 1) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: step, behavior: 'smooth' });
    }
  }

  get saved() {
    try {
      return JSON.parse(localStorage.getItem('lua:wishlist') || '[]');
    } catch (error) {
      return [];
    }
  }

  restoreWishlist() {
    const saved = this.saved;
    this.querySelectorAll('[data-wish]').forEach((button) => {
      if (saved.includes(button.dataset.wish)) {
        button.setAttribute('aria-pressed', 'true');
      }
    });
  }

  onClick = (event) => {
    const button = event.target.closest('[data-wish]');
    if (!button) return;

    const id = button.dataset.wish;
    const saved = this.saved;
    const next = saved.includes(id) ? saved.filter((item) => item !== id) : saved.concat(id);

    button.setAttribute('aria-pressed', String(next.includes(id)));

    try {
      localStorage.setItem('lua:wishlist', JSON.stringify(next));
    } catch (error) {
      // Storage unavailable (private mode); the visual state still toggles.
    }
  };
}

if (!customElements.get('lua-carousel')) {
  customElements.define('lua-carousel', LuaCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-d-best-sellers"] && !Shopify.designMode) return;
  try {
    
/*
  Mueve el carrusel de Best Sellers con los dos botones que sustituyeron al
  enlace "View all". Un salto = el ancho visible completo, así que avanza de
  cuatro en cuatro sin que haya que saber cuántas tarjetas hay.

  Los botones se atenúan al llegar a cada extremo, y el estado se recalcula
  al desplazar (también a mano o con el trackpad) y al redimensionar. Sin
  dependencias y sin tocar el marcado de las tarjetas.

  AUTOPLAY, 09/08/2026 a petición ("que se deslize automatico y se vayan
  viendo los productos"). Reglas, todas para que no se sienta como un
  carrusel que se impone:
  · Se para en cuanto el ratón o el foco entran en la sección, y no vuelve a
    moverse hasta que salen -- un carrusel que sigue corriendo mientras
    alguien intenta leer o hacer clic es el motivo por el que casi todos se
    odian.
  · Respeta prefers-reduced-motion: si el sistema pide menos movimiento, no
    arranca -- igual que ya hacía el scroll-behavior manual más abajo.
  · Se para si la pestaña no está visible (document.hidden), para no gastar
    ciclos ni volver con un salto brusco al volver a mirarla.
  · Al llegar al final vuelve al principio (scrollTo left:0), no rebota:
    es una vitrina en bucle, no una paginación con fin.
  · Un clic manual en las flechas reinicia el temporizador, para que el
    autoplay no compita con lo que la persona acaba de pedir.
*/
(function () {
  function init(section) {
    const row = section.querySelector('.luad-bs__grid');
    const nav = section.querySelector('.luad-bs__nav');
    if (!row) return;

    const arrows = nav ? [...nav.querySelectorAll('.luad-bs__arrow')] : [];

    function sync() {
      const max = row.scrollWidth - row.clientWidth;
      const x = Math.round(row.scrollLeft);
      arrows.forEach((b) => {
        const back = b.dataset.dir === '-1';
        b.disabled = max <= 1 || (back ? x <= 1 : x >= max - 1);
      });
    }

    arrows.forEach((b) => {
      b.addEventListener('click', () => {
        row.scrollBy({ left: Number(b.dataset.dir) * row.clientWidth, behavior: 'smooth' });
        restartAutoplay();
      });
    });

    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    const AUTOPLAY_MS = 4500;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    let paused = false;

    function maxScroll() {
      return row.scrollWidth - row.clientWidth;
    }

    function tick() {
      if (paused || document.hidden) return;
      const max = maxScroll();
      if (max <= 1) return;
      if (row.scrollLeft >= max - 1) {
        row.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        row.scrollBy({ left: row.clientWidth, behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      if (reducedMotion || maxScroll() <= 1) return;
      stopAutoplay();
      timer = window.setInterval(tick, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restartAutoplay() {
      if (!paused) startAutoplay();
    }

    section.addEventListener('mouseenter', () => {
      paused = true;
      stopAutoplay();
    });
    section.addEventListener('mouseleave', () => {
      paused = false;
      startAutoplay();
    });
    section.addEventListener('focusin', () => {
      paused = true;
      stopAutoplay();
    });
    section.addEventListener('focusout', () => {
      paused = false;
      startAutoplay();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else restartAutoplay();
    });

    startAutoplay();
  }

  document.querySelectorAll('.luad-bs').forEach(init);

  // El editor de temas recarga secciones sueltas sin recargar la página.
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.luad-bs').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-favorites"] && !Shopify.designMode) return;
  try {
    
function luaFavoritesStart() {
  const root = document.querySelector('.lua-fav');
  if (!root) return;

  const source = root.querySelector('[data-lua-fav-catalogue]');
  const grid = root.querySelector('[data-lua-fav-grid]');
  const empty = root.querySelector('[data-lua-fav-empty]');

  let catalogue = [];
  try {
    catalogue = JSON.parse(source.textContent);
  } catch (error) {
    catalogue = [];
  }

  const byId = new Map(catalogue.map((item) => [String(item.id), item]));

  function saved() {
    // El módulo compartido es la única fuente; aquí no se vuelve a leer
    // el almacenamiento a mano para que el formato no pueda divergir.
    return window.LuaWishlist ? window.LuaWishlist.read() : [];
  }

  function card(item) {
    const article = document.createElement('article');
    article.className = 'lua-fav__card';

    const price = item.compareAt
      ? `<span class="lua-fav__price">${item.price}</span>
         <s class="lua-fav__was">${item.compareAt}</s>`
      : `<span class="lua-fav__price">${item.price}</span>`;

    article.innerHTML = `
      <a class="lua-fav__link" href="${item.url}">
        <span class="lua-fav__frame">
          ${
            item.image
              ? `<img class="lua-fav__img" src="${item.image}" alt="${item.alt || ''}" loading="lazy">`
              : ''
          }
        </span>
        <span class="lua-fav__name">${item.title}</span>
        <span class="lua-fav__prices">${price}</span>
      </a>
    `;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'lua-wish';
    button.dataset.luaWish = String(item.id);
    button.setAttribute('aria-pressed', 'true');
    button.setAttribute('aria-label', `Remove ${item.title} from favorites`);
    button.innerHTML =
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<path d="M10 15.14s-5.75-3.53-5.75-7.36A3.37 3.37 0 0 1 10 5.86a3.37 3.37 0 0 1 5.75 1.92c0 3.83-5.75 7.36-5.75 7.36Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';

    article.prepend(button);
    return article;
  }

  function render() {
    /*
      Se recorre lo guardado, no el catálogo, para respetar el orden en que
      el cliente fue añadiendo. Los identificadores que ya no existen —un
      producto retirado— se ignoran sin avisar: no es un error suyo.
    */
    const items = saved()
      .map((id) => byId.get(id))
      .filter(Boolean);

    grid.replaceChildren(...items.map(card));
    grid.toggleAttribute('hidden', items.length === 0);
    empty.toggleAttribute('hidden', items.length > 0);
  }

  /*
    Se vuelve a pintar al cambiar la lista, y así al quitar un favorito la
    tarjeta desaparece en el momento en vez de quedarse con el corazón
    apagado.
  */
  document.addEventListener('lua:wishlist:change', render);

  render();
}

/*
  El paquete de la sección puede llegar antes que el marcado. Sin esta
  guarda, el querySelector de arriba devolvía null, la función salía sin
  hacer nada y la página se quedaba en blanco —ni rejilla, ni estado
  vacío— porque los dos nacen con `hidden`.
*/
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', luaFavoritesStart);
} else {
  luaFavoritesStart();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-product-benefits"] && !Shopify.designMode) return;
  try {
    
/*
  La sección se declara después de "main" en el orden de la plantilla, así
  que por defecto cae debajo de TODO el bloque de producto. A petición
  ("lo quiero justo aquí debajo de la foto") se reubica justo detrás de
  <media-gallery>, el mismo recurso que ya usa
  blocks/lua-product-gallery-overlay.liquid — y por el mismo motivo: no se
  puede anidar dentro de la galería desde el schema, porque el schema de
  product-information sólo admite bloques @app.

  Si no encontrara la galería no hace nada, y la franja se queda donde
  Shopify la puso: se mueve o no se mueve, pero no desaparece.
*/
class LuaPbenMount extends HTMLElement {
  connectedCallback() {
    if (this.dataset.moved) return;
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    this.dataset.moved = '1';
    gallery.insertAdjacentElement('afterend', this);
  }
}

if (!customElements.get('lua-pben-mount')) {
  customElements.define('lua-pben-mount', LuaPbenMount);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lua-product-size-guide"] && !Shopify.designMode) return;
  try {
    
/*
  LA GUÍA VA JUNTO A LAS TALLAS, no en su propia franja al final de la
  página: es donde surge la duda que resuelve.

  Hay que moverla con JavaScript porque el selector de tallas no lo pinta
  el tema, lo pinta la app Globo Color Swatch —su CSS oculta el selector
  nativo— y una sección de Liquid no puede renderizarse dentro de algo que
  todavía no existe cuando el servidor responde.

  Se reintenta durante unos segundos porque la app monta asíncrona. Si no
  llega a aparecer, la franja se queda donde está: sigue siendo útil, sólo
  que más abajo.
*/
class LuaSizeGuideMount extends HTMLElement {
  connectedCallback() {
    this.intentos = 0;
    this.buscar();
  }

  buscar = () => {
    if (this.colocada) return;

    /*
      Se ancla al rótulo de la opción de TALLA, no al primer selector que
      aparezca: varios productos tienen también Colour, y son dos bloques
      `.swatch--gl` distintos.
    */
    const rotulo = [...document.querySelectorAll('.swatch--gl legend')].find((l) =>
      /size|talla/i.test(l.textContent)
    );

    if (rotulo) {
      rotulo.insertAdjacentElement('afterend', this);
      rotulo.closest('.swatch--gl')?.classList.add('lua-sguide-host');
      this.colocada = true;
      this.classList.add('lua-sguide--inline');
      return;
    }

    if (this.intentos++ < 40) setTimeout(this.buscar, 150);
  };
}

if (!customElements.get('lua-sguide-mount')) {
  customElements.define('lua-sguide-mount', LuaSizeGuideMount);
}

document.addEventListener('click', (event) => {
  const abrir = event.target.closest('[data-lua-sguide-open]');
  if (abrir) {
    const dialogo = document.getElementById(abrir.dataset.luaSguideOpen);
    if (dialogo) dialogo.showModal();
    return;
  }

  const cerrar = event.target.closest('[data-lua-sguide-close]');
  if (cerrar) {
    cerrar.closest('dialog')?.close();
    return;
  }

  /*
    Clic fuera del contenido. El <dialog> ocupa toda la pantalla con su
    ::backdrop, así que un clic en el fondo llega al propio dialog y no a
    sus hijos: comparar el objetivo con el diálogo distingue los dos casos
    sin necesidad de una capa extra.
  */
  const dialogo = event.target.closest('dialog.lua-sguide__dialog');
  if (dialogo && event.target === dialogo) dialogo.close();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
